import { AfterContentChecked, AfterViewInit, EventEmitter, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { SidebarNavService } from "@app/shared/cs-components/sidebar-nav/services/sidebar-nav.service";
var SidebarNavComponent = /** @class */ (function () {
    function SidebarNavComponent(changeDetector) {
        this.changeDetector = changeDetector;
        this.navService = undefined;
        this.themeName = 'stepper';
        this.updatedActiveItem = new EventEmitter();
        this.stepHeader = 'Step';
        this.totalProgress = 0;
        this.isViewInit = false;
    }
    SidebarNavComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menuItems = this.navService.getMenuItems();
        this.showProgressBar = this.navService.showProgressBar();
        this.subscription = this.navService.triggerEvent$.subscribe({
            next: function (event) {
                var action = event['actionName'];
                if (action) {
                    delete event.actionName;
                }
                if (action === SidebarNavService.CONSTANTS['onCurrentActiveItem']) {
                    var currentActiveItem = event.currentActiveItem, totalProgress = event.totalProgress;
                    var currentItem = currentActiveItem;
                    _this.totalProgress = totalProgress;
                    if (_this.isViewInit) {
                        _this.updatedActiveItem.emit(currentActiveItem);
                    }
                    _this.currentItem = currentItem;
                }
            }
        });
    };
    SidebarNavComponent.prototype.menuItemClick = function (index, groupId) {
        if (index === void 0) { index = undefined; }
        if (groupId === void 0) { groupId = undefined; }
        if (this.currentIndex == index) {
            return;
        }
        var item;
        if (groupId == undefined) {
            item = this.menuItems[index];
        }
        else {
            var groupItems = this.navService.menuItemsGroup[groupId];
            item = groupItems[index];
        }
        if (item.status === 'pending') {
            return;
        }
        if (groupId) {
            this.navService.setActiveGroupItem(groupId, item.id);
        }
        else {
            this.navService.setActiveItem(item.id);
        }
    };
    SidebarNavComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.isViewInit = true;
        setTimeout(function () { _this.navService.setActiveItem(); }, 300);
    };
    SidebarNavComponent.prototype.ngOnDestroy = function () {
        if (this.subscription)
            this.subscription.unsubscribe();
    };
    SidebarNavComponent.prototype.ngAfterContentChecked = function () {
        this.changeDetector.detectChanges();
    };
    return SidebarNavComponent;
}());
export { SidebarNavComponent };
